/**
 * Whether a Stream channel came from a marketing campaign. Mirrors
 * `InboxInfoSources` in stream-chat-backend (`internal/domain/inbox_index.go`).
 * The read model is the authority for
 * LISTING; this is the per-channel signal for RENDERING, which the wire shape
 * does not carry: `InboxQueryResult` returns ids only, so a row answers for itself.
 *
 * `career_fair` is `InboxHiddenSources` upstream, a different verdict. A channel
 * minted before the backend stamped `data.source` carries none, so absence means
 * "unknown", not "not marketing".
 */
const INFO_SOURCE = 'marketing_campaign';

export function isInfoSource(source: unknown): boolean {
  return source === INFO_SOURCE;
}

/** Marketing-persona ids, the signal this used before the backend stamped a source. */
const BROADCAST_SUFFIX = /_(ajt|rb|mk)$/;

/**
 * Whether a channel is a platform announcement rather than a conversation with
 * a person, from the two fields that can say so.
 *
 * Lifted out of the client's `rules.ts` when the widget's unread badge needed
 * the same verdict server-side: the badge counts chats an employer can act on,
 * and a marketing blast is neither. Two copies of this rule would drift, and the
 * drift would show up as a badge that disagrees with the list behind it.
 *
 * The source is authoritative; the member-id suffix stays only for channels the
 * AI-2336 backfill did not stamp, which `isInfoSource` cannot tell from a chat.
 */
export function isBroadcastChannel(source: unknown, memberIds: readonly string[]): boolean {
  return isInfoSource(source) || memberIds.some((id) => BROADCAST_SUFFIX.test(id));
}
